import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  FormGroup, Label, Row, Col, FormText,
} from 'reactstrap';
import { Field } from 'redux-form';
import {
  renderInput, required, Required, postCode, numberOnly, maxLength, minLength, kana, email,
} from '../../helpers/formHelper';
import * as Actions from '../../actions/postCodeActions';

const minLength8 = minLength(8);
const maxLength32 = maxLength(32);

class View extends PureComponent {
  render() {
    const { onChangePostCode, name, formName } = this.props;
    return (
      <>
        <FormGroup>
          <Label>保護者さま氏名</Label>
          <Required />
          <Row>
            <Col style={{ paddingRight: '5px' }}>
              <Field
                placeholder="姓"
                name={`${name}[last_name]`}
                type="input"
                component={renderInput}
                validate={[required]}
              />
            </Col>
            <Col style={{ paddingLeft: '5px' }}>
              <Field
                placeholder="名"
                name={`${name}[first_name]`}
                type="input"
                component={renderInput}
                validate={[required]}
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col style={{ paddingRight: '5px' }}>
              <Field
                placeholder="セイ"
                name={`${name}[last_name_kana]`}
                type="input"
                component={renderInput}
                validate={[required, kana]}
              />
            </Col>
            <Col style={{ paddingLeft: '5px' }}>
              <Field
                placeholder="メイ"
                name={`${name}[first_name_kana]`}
                type="input"
                component={renderInput}
                validate={[required, kana]}
              />
            </Col>
          </Row>
        </FormGroup>
        <FormGroup>
          <Label>メールアドレス</Label>
          <Required />
          <Field
            placeholder="メールアドレスを入力"
            name={`${name}[email]`}
            type="input"
            component={renderInput}
            validate={[required, email]}
          />
          <FormText color="danger" style={{ marginTop: '10px' }}>
            お申込み後、弊社からのご連絡は、原則メールでのご案内となります。
            <br />
            必ずPCのメールアドレスをご入力ください。
            <br />
            携帯電話のメールアドレス（@docomo.ne.jp, ezweb.ne.jp, softbank.ne.jp 等）の場合、重要なメールが届かないことがあります。
          </FormText>
        </FormGroup>
        <FormGroup>
          <Label>お客さまパスワード</Label>
          <Required />
          <Field
            placeholder="お客さまパスワードを入力"
            name={`${name}[password]`}
            type="password"
            component={renderInput}
            validate={[required, minLength8, maxLength32]}
          />
          <FormText style={{ marginTop: '10px' }}>
            マイページ（MEMBERS）パスワードは、申込情報の確認や変更のために必要です。
            <br />
            パスワードは英数字8文字以上32文字以下でお願いいたします。
          </FormText>
        </FormGroup>
        <FormGroup>
          <Label>電話番号</Label>
          <Required />
          <Field
            placeholder="電話番号を入力"
            name={`${name}[phone]`}
            type="input"
            component={renderInput}
            validate={[required]}
          />
        </FormGroup>
        <FormGroup>
          <Label>郵便番号</Label>
          <Required />
          <Field
            placeholder="1230000"
            name={`${name}[post_code]`}
            type="input"
            component={renderInput}
            validate={[required, postCode]}
            normalize={numberOnly}
            onChange={(e) => onChangePostCode(e.target.value, formName, name)}
          />
        </FormGroup>
        <FormGroup>
          <Label>都道府県</Label>
          <Required />
          <Field
            placeholder="東京都"
            name={`${name}[prefecture]`}
            type="input"
            component={renderInput}
            validate={[required]}
          />
        </FormGroup>
        <FormGroup>
          <Label>市区町村</Label>
          <Required />
          <Field
            placeholder="渋谷区"
            name={`${name}[address1]`}
            type="input"
            component={renderInput}
            validate={[required]}
          />
        </FormGroup>
        <FormGroup>
          <Label>町名・番地・建物・部屋番号</Label>
          <Required />
          <Field
            placeholder="渋谷1-1-1 ライフイズテックマンション505号室"
            name={`${name}[address2]`}
            type="input"
            component={renderInput}
            validate={[required]}
          />
        </FormGroup>
        <FormGroup>
          <Label>メールマガジンの配信</Label>
          <Required />
          <br />
          <FormGroup inline check>
            <Field
              type="radio"
              value="true"
              component={renderInput}
              validate={[required]}
              name={`${name}[send_mail_magazine]`}
              label="配信を希望する"
              id="send_mail_magazine0"
            />
            {' '}
          </FormGroup>
          <FormGroup inline check>
            <Field
              type="radio"
              value="false"
              component={renderInput}
              validate={[required]}
              name={`${name}[send_mail_magazine]`}
              label="配信を希望しない"
              id="send_mail_magazine1"
            />
            {' '}
          </FormGroup>
        </FormGroup>
      </>
    );
  }
}

View.defaultProps = {
  name: 'parent',
};

View.propTypes = {
  onChangePostCode: PropTypes.func.isRequired,
  name: PropTypes.string,
  formName: PropTypes.string.isRequired,
};

export default connect(null, (dispatch) => ({
  onChangePostCode: (zipcode, formName, name) => dispatch({
    type: Actions.SAGA_GET_POST_CODE,
    payload: {
      zipcode,
      formName,
      name,
    },
  }),
}))(View);
